export function formatOrderId(id) {
  if (!id || id === '—') return id;
  return id.slice(0, 3).toUpperCase() + '-' + id.slice(-4).toUpperCase();
}

export function formatTransactionId(docId, createdAt) {
  if (!docId || docId === '—') return docId;
  const d = createdAt?.toDate ? createdAt.toDate() : createdAt ? new Date(createdAt) : new Date();
  const date = d.toISOString().slice(0, 10).replace(/-/g, '');
  const digits = docId.replace(/\D/g, '').slice(0, 4).padStart(4, docId.slice(-4).replace(/\D/g, '0'));
  return `TRN-${date}-${digits.slice(0, 4)}`;
}
